<template>
    <div class="input-container">
        <b-dropdown
            :text="textValueDropdown"
            class="ddl-input"
            variant="none"
            toggle-class="customDropdown"
            menu-class="ddl-menu"
            no-caret
        >
            <template slot="button-content">
                <div class="img-container">
                    <img
                        class="datepicker-icon"
                        src="@/assets/campaignlist/icon_clock.svg"
                        alt=""
                    />
                </div>
                <div class="content-container">
                    {{ content }}
                </div>
                <span class="white-caret">
                    <img
                        class="white-arrow"
                        src="@/assets/home/white_dropdown.svg"
                    />
                </span>
            </template>
            <b-dropdown-item
                v-for="(v, k) in dropdownList"
                :key="k"
                @click="onChange(v)"

            >
                {{ v.text }}
            </b-dropdown-item>
        </b-dropdown>
    </div>
</template>

<script>
export default {
    name: "DatePicker",
    props: {
        value: String,
        workingTime: String,
    },
    data() {
        return {
            content: this.value,
            dropdownList: [],
            textValueDropdown: ""
        };
    },
    created() {
        if (this.workingTime) {
            this.dropdownListSetup();
            this.content = 'กรุณาเลือกเวลา';
        } else {
            this.dropdownList.push({ text: "กรุณาเลือกสาขา" });
            this.content = 'กรุณาเลือกสาขา';
        }
    },
    methods: {
        dropdownListSetup() {
            let test = "จ-อา 10:30 - 22.00";
            let startTime = test.split(" ")[1];
            let endTime = test.split(" ")[3];
            let startMinute = this.convertToMinute(startTime);
            let endMinute = this.convertToMinute(endTime);

            for (let i = startMinute; i <= endMinute; i += 15) {
                this.dropdownList.push({ text: this.convertToTime(i) });
            }
        },
        convertToMinute(time) {
            if (time.includes(":")) {
                let hour = parseInt(time.split(":")[0]) * 60;
                let minute = parseInt(time.split(":")[1]);
                return hour + minute;
            } else if (time.includes(".")) {
                let hour = parseInt(time.split(".")[0]) * 60;
                let minute = parseInt(time.split(".")[1]);
                return hour + minute;
            }
        },
        convertToTime(minute) {
            let hour = Math.floor(minute / 60);
            let hourMinute = minute % 60 === 0 ? "00" : minute % 60 
            return `${hour} : ${hourMinute}`;
        },
        onChange: function(selected) {
            this.textValueDropdown = selected.text;
            this.content = this.textValueDropdown;
            let timeObject = {'name': 'time', 'value': selected}
            this.$emit("setStartTime", timeObject);
        }
    }
};
</script>

<style lang="scss" scoped>
::v-deep .ddl-input {
    .img-container {
        height: 100%;
        display: flex;
        align-items: center;
    }
    .customDropdown {
        display: flex;
        justify-content: space-between;
        color: #fff;
        .content-container{
            text-align: start;
            padding-left: 10px;
            flex: 1;
        }
    }
    .dropdown-item{
        font-size: 16px;
    }
}
</style>
